<template>
  <div class="w-full">
    <DatatableReportV3
      v-if="tenantLoaded"
      id="jobs_table"
      ref="jobs_datatable"
      title="All Jobs"
      :source="source"
      :config="config"
      :filters="filters"
    />
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

import CONSTANTS from "@/Constants.js";
import DepartmentLink from "@/Department/DepartmentLink.vue";
import JobOpportunityLink from "@/Job/Opportunity/JobOpportunityLink.vue";
import DatatableReportV3 from "@/Reports/DatatableReportV3.vue";
import store from "@/vuex/store";
import JobsActionsContextMenu from "./JobsActionsContextMenu.vue";
import TagList from "@/Tags/TagList.vue";

export default {
  components: {
    DatatableReportV3
  },
  props: {
    source: {
      type: String,
      default: ""
    },
    filters: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapState({
      tenantLoaded({ tenant }) {
        return !!tenant;
      }
    }),
    ...mapGetters(["jobStatusEnabled"]),
    config() {
      return {
        order: [[3, "desc"]],
        columns: [
          {
            data: "job",
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.jobs
          },
          {
            data: "job_status",
            title: "Job Status",
            filterName: "job_status_id",
            orderable: false,
            visible: this.jobStatusEnabled
          },
          { data: "tags", title: "Tags", orderable: false },
          {
            data: "customer",
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.customers,
            footerClassName: "aggregate-number"
          },
          {
            data: "customer_email",
            title: "Email"
          },
          {
            data: "customer_phone",
            title: "Phone"
          },
          { data: "location_name", title: "Location Name" },
          {
            data: "address",
            orderable: false
          },
          {
            data: "first_appointment",
            title: "First Appointment"
          },
          {
            data: "appts",
            title: "Appts",
            searchable: false,
            orderable: false
          },
          {
            data: "department",
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.departments,
            filterName: "department_id"
          },
          {
            data: "technician",
            title: "Opportunity Owner",
            filterName: "technician_id"
          },
          {
            data: "opportunity_status",
            title: "Opportunity"
          },
          {
            data: "quotes_accepted",
            title: "Accepted Quotes",
            orderable: false,
            searchable: false
          },
          {
            data: "job_total",
            title: "Total",
            searchable: false,
            className: "text-right",
            footerClassName: "aggregate-currency",
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.total
          },
          {
            data: "job_balance",
            title: "Balance",
            searchable: false,
            className: "text-right",
            footerClassName: "aggregate-currency",
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.balance
          },
          {
            data: "actions",
            title: "",
            orderable: false,
            className: "text-center th-no-text",
            searchable: false
          }
        ],
        vueComponents: [
          {
            rootId: "department-modal-vue",
            component: DepartmentLink,
            options: {
              store
            }
          },
          {
            rootId: "job-opportunity-modal-vue",
            component: JobOpportunityLink,
            options: {
              store
            }
          },
          {
            rootId: "jobs-context-menu-vue",
            component: JobsActionsContextMenu,
            options: {
              store
            }
          },
          {
            rootId: "tag-list-vue",
            component: TagList
          }
        ]
      };
    }
  }
};
</script>
